import React from "react";
import { ISubscriptionData } from "../../services/dashboard.services";
import CurrentSubscriptionItemLayout from "./CurrentSubscriptionItemLayout";

export default function CurrentSubscriptionData(props: IProps) {
  const { subscription_items } = props.subscriptionData;

  return (
    <React.Fragment>
      {subscription_items &&
        subscription_items.map((subItem, index) => {
          return (
            <CurrentSubscriptionItemLayout
              key={subItem.id}
              amount={subItem.amount}
              id={subItem.id}
              quantity={subItem.quantity}
              product={subItem.product}
              productID={subItem.product_id}
            ></CurrentSubscriptionItemLayout>
          );
        })}
    </React.Fragment>
  );
}

interface IProps {
  subscriptionData: ISubscriptionData;
}
